import React, { useContext, useEffect, useState } from "react";
import "./styles.scss";
import NavItem from "./NavItem";
import api from "../../factory/api";
import { useHistory } from "react-router-dom";
import { AppContext } from "../../contexts/AppContext";
import { generateAuthorizationToken } from "../../services/utils";

export default function SideNav() {
    const history = useHistory();

    const { appInfo } = useContext(AppContext)

    const [menu, setMenu] = useState([])
    const [openedItem, setOpenedItem] = useState()

    useEffect(() => {
        if (appInfo?.accessKey)
            getMenu()
    }, [appInfo])

    const getMenu = async () => {
        try {
            let Authorization = generateAuthorizationToken(appInfo)

            let { data } = await api.get("/central/app/menu", { headers: { Authorization } })

            let { menu = [] } = data

            setMenu(menu)
        } catch (error) {
            console.error(error)
        }
    }

    const onClick = (item) => {
        if (item.availability == "private") return;

        setOpenedItem(item)

        // "iframe" | "plugin" | "redirect" | "link"

        if (item.type == "plugin")
            history.push("/plugin", item)
        else if (item.type == "iframe")
            history.push("/iframe", item)
        else if (item.type == "redirect") {
            let path = item.url?.[0] == "/" ? item.url : `/${item.url}`
            let url = `https://${appInfo.tenantId}.blip.ai${path}`
            window.open(url);
        } else if (item.type == "link" && item.url) {
            window.open(item.url, "_blank");
        }
    }

    return (
        <aside className="sidenav">
            <div className="options">
                {/* {JSON.stringify(openedItem || {})} */}
                {menu.map((item) =>
                    <NavItem
                        icon={item.icon}
                        text={item.title}
                        secondaryText={item.subtitle}
                        onClick={() => onClick(item)}
                        isOpen={item._id == openedItem?._id}
                        isBlocked={item.availability == "private"}
                    />
                )}
                {/* 
                <bds-nav-tree icon="heart" text="Título" secondary-text="Breve Descrição">
                    <bds-nav-tree-item icon="heart" text="Título"></bds-nav-tree-item>
                    <bds-nav-tree-item text="Título" secondary-text="Breve Descrição">
                        <bds-nav-tree-item icon="heart" text="Título" isOpen></bds-nav-tree-item>
                        <bds-nav-tree-item icon="heart" text="Título"></bds-nav-tree-item>
                    </bds-nav-tree-item>
                    <bds-nav-tree-item icon="heart" text="Título" secondary-text="Breve Descrição">
                        <bds-nav-tree-item text="Título"></bds-nav-tree-item>
                        <bds-nav-tree-item icon="heart" text="Título"></bds-nav-tree-item>
                        <bds-nav-tree-item icon="heart" text="Título" secondary-text="Breve Descrição"></bds-nav-tree-item>
                        <bds-nav-tree-item text="Título" secondary-text="Breve Descrição"></bds-nav-tree-item>
                    </bds-nav-tree-item>
                </bds-nav-tree> */}
            </div>
            <div>

            </div>
        </aside>
    );
}
